import { ADVANCED_ONBOARDING } from '@sputnik/resources/constants'

export const setReturnFlowLocalStorage = (returnFlowParam?: string | null) => {
  if (returnFlowParam === ADVANCED_ONBOARDING) {
    window.localStorage.setItem('returnFlow', returnFlowParam)
  }
}

export const getReturnFlowLocalStorage = () => window.localStorage.getItem('returnFlow')
